import SXMLink from '@/shared-components/SXMLink';
import Button, { ButtonProps } from 'de-sxm-reactlib-2/components/atoms/Button/Button';
import { ContentfulComponent } from '../type';
import { siteLinkToWeb2ButtonProps } from './linkPropUtils';
import ImageWrapper from '@/shared-components/ImageWrapper/ImageWrapper';
import ChatLink from './ChatLink';
import styles from './link.module.scss';
import cn from 'classnames';

const LinkCRC: ContentfulComponent<SiteLink> = function ({ asset, children }): React.JSX.Element {
    const target = asset.fields.type === 'New Tab' ? '_blank' : '_self';
    let variant:ButtonProps['variant'] = 'primary';

    if(asset.fields.link_type === 'Secondary CTA') {
        variant = 'secondary';
    } else if(asset.fields.link_type === 'Tertiary') {
        variant = 'tertiary';
    }

    if (asset.fields.type === 'Chat') {
        return (
            <ChatLink
                type={asset.fields.link_type}
                variant={variant}
                
                colorSet={asset.fields.colorSet}
                text={asset.fields.link_text}
                iconUrl={asset.fields.media?.url}
                iconWidth={asset.fields.media?.width}
                iconHeight={asset.fields.media?.height}
            />
        );
    } else if (asset.fields.type === 'Manage Cookies') {
        return (
            <a href="#" className="ot-sdk-show-settings">
                {asset.fields.link_text}
            </a>
        );
    } else if (asset.fields.type === 'Call Center') {
        // needs UX if still used, if/when used, should be a separate component under this directory
    } else if (asset.fields.link_type === 'Text') {
        return (
            <SXMLink
                href={asset.fields.href || ''}
                target={target}
                aria-label={asset.fields.aria_label || asset.fields.link_text}
                inheritParams={asset.fields.inheritParams}
            >
                {asset.fields.media?.url ? (
                    <ImageWrapper
                        src={asset.fields.media.url}
                        alt={asset.fields.media.altText}
                        optimizedHeight={asset.fields.media.height}
                        optimizedWidth={asset.fields.media.width}
                    />
                ) : (
                    asset.fields.link_text
                )}
                {children}
            </SXMLink>
        );
    } else if (
        asset.fields.link_type &&
        (asset.fields.link_type.indexOf('CTA') >= 0 || asset.fields.link_type === 'Tertiary')
    ) {
        const btnProps = siteLinkToWeb2ButtonProps(asset.fields);
        const isTertiary = asset.fields.link_type === 'Tertiary';

        return (
            <div className={styles.ctaWrap}>
                <Button {...btnProps} className={cn(btnProps.className, isTertiary && styles.tertiary)} />
            </div>
        );
    } else if (asset.fields.link_type === 'LinkInfoCard') {
        // needs UX if still used, if/when used, should be a separate component under this directory
    }

    return <>Link</>;
};

export default LinkCRC;
